import { render } from "./DialogIncasso.vue?vue&type=template&id=b0b6d628"
import script from "./DialogIncasso.vue?vue&type=script&lang=js"
export * from "./DialogIncasso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__